import { DirectiveBinding } from 'vue';

// interface DirectiveElement extends Element {
//     observer?: any;
// }

export default {
    name: 'observer',
	mounted(el: Element, binding: DirectiveBinding) {
        if (binding.value == undefined) return;

        // @ts-ignore
        el.observer = new IntersectionObserver(([entry]) => {
			if (entry?.isIntersecting) {
				binding.value?.();
			}
        }, {
			root: el?.parentElement,
			rootMargin: '0px',
            threshold: 1.0
        });

        // @ts-ignore
        el.observer?.observe?.(el);
	},
    beforeUnmount(el: Element, binding: DirectiveBinding) {
        // @ts-ignore
        if (binding.value == undefined || !el?.observer) return;

        // @ts-ignore
        el.observer?.unobserve?.(el);
    },
}